// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
import { Checkbox } from "@components/ui/checkbox";
import React, { useContext, useImperativeHandle, useState } from "react";
import { MeetingContext } from "../CreateMeetingPage";
import { ICompanyId, IJobCreator } from "@endpoints/types/candidate.type";
import { ITeamMember } from "@type/hiringStaff.type";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import HiringTeamMembers from "../components/HiringTeamMembers";

const AttendeeSection = React.forwardRef((_, ref) => {
  const userDetails = useSelector((state: RootState) => state.auth?.user);
  const { meetingRequirements } = useContext(MeetingContext);
  const [selectedRecruiter, setSelectedRecruiter] = useState<ICompanyId>();
  const [selectedHiringMembers, setSelectedHiringMembers] = useState<
    ITeamMember[]
  >([]);

  function handleSelectOrDeselectMember(memberDetail: ITeamMember) {
    const isMemberExist = selectedHiringMembers?.find(
      (item) => item?._id === memberDetail?._id
    );
    if (isMemberExist) {
      const hiringTeamMembers = selectedHiringMembers?.filter(
        (item) => item?._id !== memberDetail?._id
      );
      setSelectedHiringMembers(hiringTeamMembers);
    } else {
      setSelectedHiringMembers((prev) => [...prev, memberDetail]);
    }
  }

  useImperativeHandle(
    ref,
    () => ({
      submit: () => {
        return selectedHiringMembers;
      },
    }),
    [selectedHiringMembers]
  );

  console.log("meetingRequirements", meetingRequirements);

  return (
    <div className="flex gap-10 mt-8 w-full">
      {/* Left section */}
      <div className="flex flex-col flex-1 gap-8">
        {/* Selecting recruitment agent */}
        <div className="flex flex-col gap-2">
          <span className="font-semibold text-xs text-primary">
            Select Recruitment agent to attend meeting
          </span>
          <div className="flex items-center gap-4 border py-2 px-5 rounded-md">
            <Checkbox
              checked={
                selectedRecruiter?._id ===
                meetingRequirements?.job?.createdBy?.companyId?._id
              }
              onClick={() => {
                const isSameId =
                  selectedRecruiter?._id ===
                  meetingRequirements?.job?.createdBy?.companyId?._id;
                if (isSameId) {
                  setSelectedRecruiter(undefined);
                } else {
                  setSelectedRecruiter(
                    meetingRequirements?.job?.createdBy?.companyId
                  );
                }
              }}
              className="w-5 h-5"
            />
            <div className="flex items-center gap-3.5">
              {meetingRequirements?.job?.createdBy?.companyId?.logo ? (
                <img
                  src={meetingRequirements?.job?.createdBy?.companyId?.logo}
                  className="w-10 h-10 rounded-md border"
                />
              ) : (
                <div className="flex justify-center items-center w-10 h-10 rounded-full bg-gray-200 font-medium text-primary">
                  {meetingRequirements?.job?.createdBy?.companyId?.name?.charAt(
                    0
                  )}
                </div>
              )}
              <div className="flex flex-col">
                <span className="text-xs font-medium text-primary">
                  {meetingRequirements?.job?.createdBy?.companyId?.name}
                </span>
                {/* <span className="text-xs text-primary">Savannah Nyugen</span> */}
              </div>
            </div>
          </div>
        </div>

        {/* Selecting hiring team members */}
        <HiringTeamMembers
          jobRequirementTeamMembers={
            meetingRequirements?.jobRequirementTeamMembers
          }
          selectedHiringMembers={selectedHiringMembers}
          handleSelectOrDeselectMember={handleSelectOrDeselectMember}
        />
      </div>

      {/* Right section */}
      <div className="flex flex-col items-center p-3 flex-1 border rounded-md gap-2">
        <span className="font-semibold text-sm">Meeting Attendee</span>
        {/* Hiring company details */}
        <div className="flex flex-col w-full bg-light-white-700 rounded-md p-3">
          <span className="font-semibold text-xs text-primary">
            Organiser details:
          </span>
          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center gap-3.5">
              {userDetails?.profilePic ? (
                <img
                  src={userDetails?.profilePic}
                  className="w-10 h-10 rounded-md"
                />
              ) : (
                <div className="flex justify-center items-center w-10 h-10 rounded-full bg-gray-200 font-medium text-primary">
                  {userDetails?.companyName?.charAt(0)}
                </div>
              )}
              <span className="text-xs font-medium text-primary">
                {userDetails?.companyName}
              </span>
            </div>
            <span className="text-xs text-light-black">
              {userDetails?.refNo}
            </span>
          </div>
          {/* Hiring team members */}
          {selectedHiringMembers?.length ? (
            <div className="flex flex-col border-t mt-3.5 pt-3.5 gap-3.5">
              <span className="font-semibold text-xs text-primary">
                Hiring team members
              </span>
              <div className="flex flex-col gap-2">
                {selectedHiringMembers?.map(() => {
                  return (
                    <div className="flex items-center gap-3.5">
                      <img src={ProfileImg} className="w-6 h-6 rounded-md" />
                      <span className="text-xs font-medium text-light-black">
                        Hiring company
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
        {/* Candidate details */}
        <div className="flex flex-col w-full bg-light-white-700 rounded-md p-3">
          <span className="font-semibold text-xs text-primary">
            Candidate details:
          </span>
          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center gap-3.5">
              {meetingRequirements?.candidate?.profilePic ? (
                <img
                  src={meetingRequirements?.candidate?.profilePic}
                  className="w-10 h-10 rounded-md"
                />
              ) : (
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 font-semibold text-primary">
                  {meetingRequirements?.candidate?.firstName?.charAt(0)}
                </div>
              )}
              <div className="flex flex-col">
                <span className="text-xs font-medium text-primary">
                  {meetingRequirements?.candidate?.firstName}{" "}
                  {meetingRequirements?.candidate?.lastName}
                </span>
                <span className="text-xs text-primary">
                  {meetingRequirements?.candidate?.email}
                </span>
              </div>
            </div>
            <span className="text-xs text-light-black">
              {meetingRequirements?.candidate?.refNo}
            </span>
          </div>
        </div>
        {/* Recruitment agent details */}
        {selectedRecruiter ? (
          <div className="flex flex-col w-full bg-light-white-700 rounded-md p-3">
            <span className="font-semibold text-xs text-primary">
              Recruitment agent details:
            </span>
            <div className="flex items-center justify-between mt-2">
              <div className="flex items-center gap-3.5">
                {selectedRecruiter?.logo ? (
                  <img
                    src={selectedRecruiter?.logo}
                    className="w-10 h-10 rounded-md"
                  />
                ) : (
                  <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-200 font-semibold text-primary">
                    {selectedRecruiter?.name?.charAt(0)}
                  </div>
                )}
                <div className="flex flex-col">
                  <span className="text-xs font-medium text-primary">
                    {selectedRecruiter?.name}
                  </span>
                  {/* <span className="text-xs text-primary">Savannah Nyugen</span> */}
                </div>
              </div>
              <span className="text-xs text-light-black">
                {selectedRecruiter?.refNo}
              </span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
});

export default AttendeeSection;
